import axiosInstance from '../utils/axiosInstance';
import type { Matter } from '../../types/matter';

interface GetMatterResponse {
  success: boolean;
  data: Matter;
}

export const getMatter = async (matterId: string): Promise<Matter> => {
  const response = await axiosInstance.get<GetMatterResponse>(`/matters/${matterId}`);
  return response.data.data;
};
